export enum carouselEnum {
  Simple = 0,
  Full = 1,
  Masonry = 2,
  FlipBox = 3,
  CardBox = 4,
  Artists = 5,
  ListsCollection = 6,
  Featured = 7,
  //new design
  Simple_H = 8,
  Simple_V = 9,
  Simple_small = 10,
  Linear = 11,
  Series = 12,
  WithDesc_V = 13,
  ArtistCircle = 14,
  Series_Small = 15,
  image_Only = 16,
  PublisherCircle = 17
}

export enum badgeTypeEnum {
  None = 0,
  Latest = 1,
  BestSeller = 2,
  Button = 3
}

export enum SliderTypeEnum {
  Normal = 0,
  BannerMode = 1
}
